import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function ArmazenaProtocoloReducer(state = initialState.protocolo, action){
    switch(action.type) {
        case types.ARMAZENA_PROTOCOLO:
            
            return action.protocolo;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/ArmazenaProtocoloReducer.js
 **/